import moment from 'moment'
import React, { Fragment } from 'react'
import styled from 'react-emotion'
import { ga } from '../../application'
import { colors } from '../../styles'
import getText from '../strings'

const ModalHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;

  .pictogram {
    height: 40px;
    width: 40px;
    cursor: pointer;
  }
`

const BookingDetails = styled('div')`
  display: flex;
  align-items: center;
`

const Case = styled('div')`
  border-top: 1px solid ${colors.tui_border};
  padding: 20px 0;
`

const CaseStatus = styled('div')`
  display: inline-block;
  padding: 9px 8px 8px 8px;
  background-color: ${(props) => (props.active ? colors.tui_red : colors.tui_green)};
  color: ${colors.tui_white};
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 0.8em;
  margin-bottom: 10px;
`

const Reminder = styled('p')``

const renderCase = (index, item, options) => {
  const active = item.status !== 'closed_case'
  const caseType = options.filter((o) => o.id === item.type)[0]

  return (
    <Case key={index}>
      <CaseStatus active={active}>{getText('selfservice', 'cases', 'status', active ? 'active' : 'closed').toUpperCase()}</CaseStatus>
      {caseType && <h3>{caseType.title}</h3>}
      <p>{item.message}</p>
      <div>
        <strong>{getText('selfservice', 'cases', 'createdAt')}:</strong>&nbsp;{moment(item.created).format('YYYY-MM-DD, HH:mm')}
      </div>
    </Case>
  )
}

export default ({ booking, cases, options, onCreateCase }) => {
  const handleShowCreateModal = () => {
    ga.buttonClick('selfservice-create-case-show')
    onCreateCase()
  }

  return (
    <Fragment>
      <ModalHeader>
        <div>
          <h2>
            {getText('selfservice', 'cases', 'title')} ({cases.length})
          </h2>
          <BookingDetails>
            <strong>{getText('selfservice', 'cases', 'bookingLabel')}:&nbsp;</strong>
            <span>
              {booking.products[0].country || ''} {booking.startDate} ({booking.bookingNumber})
            </span>
          </BookingDetails>
        </div>
        <button className="btn btn-function" onClick={handleShowCreateModal}>
          {getText('selfservice', 'newCase', 'submit')}
        </button>
      </ModalHeader>
      <Reminder>{getText('selfservice', 'cases', 'reminder')}</Reminder>
      <div>{cases.map((c, index) => renderCase(index, c, options))}</div>
    </Fragment>
  )
}
